import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';
import SpecLink from '../../SpecLink';

function ReportingPage() {
    return <Page header="Reporting">
        <p>
            Allows you to retrieve reports about the transactions that have been made.
        </p>

        <h2>Settlement Reports</h2>
        <p>
            <SpecLink uriFragment="#tag/Reporting">Settlement reports</SpecLink> are available for individual settlement dates. Settlement dates are typically dictated by your bank. 
            Reports contain breakdowns and sub-totals by card type/scheme as well as actions (payment, refund, etc).
        </p>
        <p>
            Transactions by module are also available:
        </p>
        <ul>
            <li>Single</li>
            <li>Multi</li>
            <li>Internet</li>
            <li>Phone</li>
            <li>Total Transactions</li>
        </ul>

        <h2>Transaction Search</h2>
        <p>
            A more generic <SpecLink uriFragment="tag/Txn/operation/Txn_SearchTxns">transaction search</SpecLink> is also available for finer grained transaction details.
        </p>

        <h2>Actions</h2>
        <Table
            headers={['Action', 'Description']}
            body={[
                [<code>Unspecified</code>, 'Any transaction'],
                [<code>Payment</code>, 'Financial transaction that debits the card'],
                [<code>Refund</code>, 'Financial transaction that credits the card'],
                [<code>UnmatchedRefund</code>, 'Unmatched refund transactions'],
                [<code>PreAuth</code>, 'Authorisation only that reserves the funds against the card. Funds are not debited until a corresponding Capture is approved.'],
                [<code>Capture</code>, 'Financial transaction that is matched to a PreAuth. When a capture is processed, the funds are debited from the card.'],
                [<code>Reversal</code>, 'Reverses a successful payment/capture. A reversal removes the original transaction from the card statement. Reversals must be made before the end of the settlement date.'],
                [<code>VerifyOnly</code>, 'Verify transactions are also known as Zero Dollar Auths. They check that the card number is valid with the Issuing Bank, however a limit check is not conducted, the funds are not reserved, and the card is not debited.'],
            ]}
         />

         <h2>Txn Source</h2>
         <Table
             headers={['Txn Source', 'Description']}
             body={[
                 [<code>Unspecified</code>, 'Any transaction source'],
                 [<code>Api</code>, 'API'],
                 [<code>CallCentre</code>, 'Call centre'],
                 [<code>CustomerPortal</code>, 'Customer portal'],
                 [<code>Internet</code>, 'Internet'],
                 [<code>IShop</code>, 'I Shop'],
                 [<code>Ivr</code>, 'IVR'],
                 [<code>BackOffice</code>, 'Back Office'],
                 [<code>MobileBackOffice</code>, 'Mobile Back Office'],
                 [<code>Sftp</code>, 'SFTP'],
             ]}
          />

          <h2>Scheme</h2>
          <Table
              headers={['Scheme', 'Description']}
              body={[
                  [<code>Unspecified</code>, 'Any scheme'],
                  [<code>Amex</code>, 'American Express'],
                  [<code>Mastercard</code>, 'Mastercard'],
                  [<code>Visa</code>, 'Visa'],
                  [<code>Diners</code>, 'Diners Club'],
                  [<code>ChinaUnionPay</code>, 'China Union Pay'],
                  [<code>Jcb</code>, 'JCB'],
                  [<code>DirectEntry</code>, 'Direct entry'],
              ]}
           />
    </Page>
}

export default ReportingPage;
